import React from 'react';
import { Heading } from '../../style/heading';

//import components
//import SkillsData from '../../content/SkillsData';
import technos from '../../content/SkillsData';
//import Categorie from './Categorie';

// import styled
import { StyledFlexContainer, StyledContainer,StyledTechnoWrapper } from './Skills_styled';

const Skills =  () => {
    
        return (
            
            <StyledContainer>
                <Heading> Mes compétences </Heading>
                <StyledFlexContainer>
                        {/* {SkillsData.map((SkillsDetail, index) => (
                                <Categorie
                                    animationName={SkillsDetail.animationName}
                                    name={SkillsDetail.name}
                                    skills={SkillsDetail.skills}
                                />
                            )
                        )}  */}
                        {technos.map((techno,index) => (
                            <StyledTechnoWrapper>
                                {techno.icon}
                                <p>{techno.name}</p>
                            </StyledTechnoWrapper>
                        ))}
            </StyledFlexContainer>
            </StyledContainer>
                
            
        );
    
}

export default Skills;


